const superUrlEncoder = (value) => {
  let newValue = encodeURIComponent(value)
  while (newValue.indexOf(".") >= 0) {
    newValue = newValue.replace(".", "%2E")
  }
  return newValue
}

module.exports = superUrlEncoder